import React from 'react';

import { Divider as MarmDivider } from '@eventbrite/marmalade';

export const Divider = ({
    id,
    className,
}: {
    id: string;
    className?: string;
}) => {
    return <MarmDivider data-testid={`divider-${id}`} className={className} />;
};
